var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExitSession(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_10",
    "data-name": "Component 1 \\u2013 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 34,
    height: 34,
    transform: "translate(965 137)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-965 -137)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(974.009 143.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1257.036,28.571v-3.3h-13.474V44.56h13.474V41.375",
    transform: "translate(-1243.563 -25.272)",
    fill: "none",
    stroke: "#a8c474",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1215.446,21.653v8.719h10.734",
    transform: "translate(-1208.709 -20.621)",
    fill: "none",
    stroke: "#a8c474",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_angle-right_",
    "data-name": "FontAwsome (angle-right)",
    d: "M31.373,101.826l-4.514,4.514a.793.793,0,0,1-1.125,0l-.75-.75a.793.793,0,0,1,0-1.125l3.2-3.2-3.2-3.2a.793.793,0,0,1,0-1.125l.747-.757a.793.793,0,0,1,1.125,0L31.37,100.7A.794.794,0,0,1,31.373,101.826Z",
    transform: "translate(-10.841 -91.511)",
    fill: "#b1cb79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExitSession);
export default __webpack_public_path__ + "static/media/icon_exit_session.773cc71b34913b937b0c3330d3e3bbca.svg";
export { ForwardRef as ReactComponent };